const e="this",n="undefined";export{e as THIS,n as UNDEFINED};
